import React from 'react';
import { classNames } from '../utils/classNames';

// A small card next to the pointer, for a hover on a drawn shape (a map cell, a chart area) that has no
// element of its own to anchor a tooltip. The caller gives the pointer position in px from the top left of
// its container (the container needs `relative`) and the size of the container. The card sits 12 px below
// and right of the pointer, and moves to the other side when it would leave the container.
// It does not take the pointer, so the shape under it keeps the hover.
// The card has the anatomy of the InfoTooltip card: white, rounded, shadow, a thin ring.
type Props = {
	x: number,
	y: number,
	containerWidth: number,
	containerHeight: number,
	title: string,
	text?: string,
	// The Tailwind fill of a small square before the title (bg-amber-500), for a colour level.
	markClassName?: string,
};

const WIDTH = 224; // w-56
const HEIGHT = 56; // two lines of text-xs and the padding
const OFFSET = 12;

const PointerTooltip: React.FunctionComponent<Props> = ({ x, y, containerWidth, containerHeight, title, text, markClassName }) => {
	const left = x + OFFSET + WIDTH > containerWidth ? Math.max(0, x - OFFSET - WIDTH) : x + OFFSET;
	const top = y + OFFSET + HEIGHT > containerHeight ? Math.max(0, y - OFFSET - HEIGHT) : y + OFFSET;
	return <div role="tooltip" style={{ left, top }}
		className="pointer-events-none absolute z-10 w-56 rounded-lg bg-white px-3 py-2 text-xs shadow-xl ring-1 ring-black ring-opacity-5">
		<p className="flex items-center gap-x-1.5 font-semibold text-gray-900">
			{markClassName !== undefined && <span aria-hidden="true" className={classNames('h-2.5 w-2.5 shrink-0 rounded-sm', markClassName)} />}
			{title}
		</p>
		{text !== undefined && <p className="mt-0.5 text-gray-600">{text}</p>}
	</div>;
};

export default PointerTooltip;
